module.exports = __webpack_public_path__ + "media/images/flags/TV-c668f109ab2dbe912d82cd0e8d6b96d9.svg";